import { useState } from 'react';
import { randomId } from '../../../../Popover/subcomponents/FocusTrap/FocusTrap.utils.mjs';
import { useIsomorphicEffect } from '../../../../utils/hooks/use-isomorphic-effect.mjs';
import { useReactId } from './use-react-id.mjs';

function useId(staticId) {
  const reactId = useReactId();
  const [uuid, setUuid] = useState(reactId);
  useIsomorphicEffect(() => {
    setUuid(randomId());
  }, []);
  if (typeof staticId === "string") {
    return staticId;
  }
  if (typeof window === "undefined") {
    return reactId;
  }
  return uuid;
}

export { useId };
